/**
 * How a submit's signature request reaches its signer.
 *
 * - `ehr`: DocuSign off; nothing is sent for signature.
 * - `embedded`: self-submit, standalone or Epic; the clinician signs here,
 *   straight after submit.
 * - `embedded-other`: a different clinician signs (standalone or Epic). provider-api
 *   emails them a link to sign in the app; the submitter stays where they are.
 */
export type SigningLane = 'ehr' | 'embedded' | 'embedded-other'

export interface SigningChannelInput {
  /** Real boolean true from isTrfSignatureDocusignEnabled. Non-boolean truthy values are treated as off. */
  docusignEnabled: boolean
  /**
   * True when a different authorizing clinician is the signer of record
   * (`submitOnBehalfOfAnother || cannotUncheckOnBehalfOf`).
   * For banner/CTA this reflects intent, not completed selection.
   */
  submittingOnBehalfOf: boolean
}

/**
 * Mirrors provider-api's channel rule so the page describes what the submit will
 * actually do: embedded whenever DocuSign is on. An Epic launch is no exception;
 * the ceremony is framed inside Hyperspace like it is in a standalone tab.
 */
export function signingLane(input: SigningChannelInput): SigningLane {
  const { docusignEnabled, submittingOnBehalfOf } = input
  if (docusignEnabled !== true) return 'ehr'
  if (submittingOnBehalfOf) return 'embedded-other'
  return 'embedded'
}
